export const isTouchDevice = (): boolean => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export const hasHover = window.matchMedia("(hover: hover)").matches;
export const isMobileOrTablet = isTouchDevice() && !hasHover;

export default isTouchDevice;
